(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8915],{

/***/ 93027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy",
      function () {
        return __webpack_require__(89957);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 89957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages_privacy; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./src/config/theme.ts
var theme = __webpack_require__(30079);
// EXTERNAL MODULE: ./src/constants/contents/contents.styled.ts
var contents_styled = __webpack_require__(25175);
;// CONCATENATED MODULE: ./src/constants/contents/privacy.tsx


var Privacy = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled/* Container */.W2, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: 'Kebijakan Privasi ini mengatur cara Stockbit mengumpulkan, menggunakan, memelihara dan mengungkapkan informasi identitas pribadi yang dikumpulkan dari pengguna (masing-masing, disebut "Pengguna") situs web Stockbit pada www.Stockbit.com ("Situs") termasuk Aplikasi Seluler Stockbit yang terdaftar di App Store dan Google Play Store, atau dikumpulkan melalui layanan jejaring sosial kami (bersama dengan Situs, disebut “Layanan”).'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: 'This Privacy Policy governs the manner in which Stockbit collects, uses, maintains and discloses personally identifiable information collected from users (each, a "User") of the Stockbit website located at www.Stockbit.com ("Site") including Stockbit Mobile App that are registered on the App Store and Google Play Store, or collected through our social networking service (together with the Site, the “Service”).'
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Dengan mengakses dan/atau menggunakan layanan Stockbit, Pengguna menyatakan bahwa setiap data Pengguna adalah data yang sah, dan Pengguna menyetujui Stockbit untuk memperoleh, mengumpulkan, menyimpan, mengelola dan menggunakan data tersebut sebagaimana tercantum dalam Kebijakan Privasi dan Syarat dan Ketentuan Stockbit."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "By accessing and/or using the Stockbit service, the user declares that each user's data is valid, and the User agrees to Stockbit to obtain, collect, store, manage and use the data as stated in the Privacy Policy and Stockbit Terms and Conditions."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Stockbit dari waktu ke waktu berhak memperbarui Kebijakan Privasi ini agar tetap relevan dan terkini dengan perubahan teknologi, hukum yang berlaku, inovasi Stockbit yang terus berkembang dan kebutuhan Pengguna, dan sebaiknya Anda memeriksa halaman ini secara berkala untuk memastikan Anda sudah mengetahui perubahan apapun."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "Stockbit from time to time has the right to renew this Privacy Policy so that it remains relevant and up-to-date with changing technology, applicable laws, Stockbit innovations that continue to evolve and User needs, and you should check this page periodically to ensure you are familiar with any changes."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Stockbit melindungi semua informasi yang diberikan oleh Pengguna ketika Pengguna menggunakan semua Layanan Stockbit."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "Stockbit protects all information provided by the User when the User uses all the Service."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "information-collection",
                children: "PENGUMPULAN INFORMASI"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "INFORMATION COLLECTION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Stockbit mengumpulkan data Pengguna dengan tujuan untuk mengelola dan memperlancar proses penggunaan Situs dan/atau Layanan, serta tujuan lainnya selama diizinkan oleh peraturan perundang-undangan yang berlaku. Data Pengguna yang dikumpulkan adalah sebagai berikut:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "Stockbit collects User data with the aim of managing and expediting the process of using the Site and/or the Service, as well as other purposes as long as permitted by applicable laws and regulations. The User data collected is as follows:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Informasi tentang Pengguna, termasuk namun tidak terbatas pada:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.UL, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Nama"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Nama Alias (jika ada)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Kebangsaan"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Alamat Sesuai KTP/Passport"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Alamat Lain (jika ada)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Status pernikahan"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Jenis kelamin"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Nomor telepon pribadi"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "E-mail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Tempat dan tanggal lahir"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Pekerjaan"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Nama ibu kandung"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Nomor KTP"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Pendapatan rata-rata per tahun"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Alamat Kantor (jika ada)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Sumber dana."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "ID Pemilik Manfaat (jika ada)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Tujuan pembukaan rekening"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Informasi lain (jika diperlukan)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Information about User, including but not limited to:"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.UL, {
                isSecondary: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Alias name (if any)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Nationality"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Address According to ID Card/Passport"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Other Address (if any)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Marital status"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Gender"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Personal phone number"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "E-mail"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Place and date of birth"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Occupation"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Biological mother's name"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "ID card (KTP) number"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Average annual income"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Office Address (if any)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Source of fund."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Beneficial Owner’s ID (if any)"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Purpose of opening account"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Other information (if needed)"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Stockbit (PT. Stockbit Sekuritas Digital) menggunakan vendor pihak ketiga dalam hal penerapan OCR (Optical Character Recognition) pada kartu identitas Pengguna guna mempermudah proses pembukaan rekening. Oleh karena itu Pengguna dengan ini setuju untuk memberikan salinan kartu identitasnya kepada vendor OCR, terbatas untuk tujuan tersebut."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "Stockbit (PT. Stockbit Sekuritas Digital) menggunakan vendor pihak ketiga dalam hal menerapkan OCR (Optical Character Recognition) pada KTP Pengguna untuk mempermudah proses pembukaan rekening. Oleh karena itu Pengguna dengan ini menyetujui untuk membagikan salinan KTP mereka dengan vendor OCR, terbatas pada tujuannya."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.LI, {
                    children: [
                        "Data yang disampaikan secara mandiri oleh Pengguna. Pengguna harus menyampaikan data Pengguna yang akurat, termasuk namun tidak terbatas pada data yang disampaikan pada saat Pengguna:",
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                            type: "a",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                    children: "Membuat atau memperbarui rekening Stockbit, termasuk nama pengguna, alamat email, nomor telepon, kata sandi, alamat, foto, dll;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                    children: "Menghubungi Stockbit, termasuk melalui layanan pelanggan;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                    children: "Berinteraksi dengan pengguna lain melalui perpesanan, streaming diskusi, ulasan, penilaian, dan sebagainya;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                    children: "Menggunakan Layanan pada Stockbit, termasuk rincian data transaksi dan/atau tip transaksi pengguna, termasuk jenis, saluran pembayaran yang digunakan, tanggal dan waktu transaksi, serta rincian transaksi lainnya;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                    children: "Menggunakan fitur yang memerlukan izin untuk mengakses perangkat Pengguna;"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                    children: "informasi yang Anda berikan kepada kami selama menggunakan Stockbit (termasuk informasi yang terkandung dalam media apapun yang diunggah untuk dipublikasikan di Situs atau aplikasi kami); dan"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                    children: "informasi lain apapun yang Anda pilih untuk dikirimkan kepada kami."
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                isSecondary: true,
                start: 2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Data submitted independently by the User. User must submitted the accurate User’s data, including but not limited to data submitted when the User:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                        isSecondary: true,
                        type: "a",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Create or renew a Stockbit account, including a username, email address, phone number, password, address, photo, etc.;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Contact Stockbit, including through customer service;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Interacting with other Users through messaging, stream discussion, reviews, ratings and so on;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Use the Service on Stockbit, including detailed transaction data and / or tip user transactions, including types, payment channels used, date and time of the transaction, as well as other transaction details;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Use features that require permission to access the User's device."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Information that you provide to us in the course of using Stockbit (including information contained in any media uploaded for publication on our site or App); and"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "any other information that you choose to send to us."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                start: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Data obtained from other sources, including:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                        type: "a",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Penyedia layanan pemasaran dan notifikasi;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Sumber yang tersedia untuk umum."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                isSecondary: true,
                start: 3,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Data obtained from other sources, including:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                        isSecondary: true,
                        type: "a",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Marketing and notification service providers;"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                                children: "Publicly available sources."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Informasi tentang komputer/ponsel Anda dan tentang kunjungan Anda dan penggunaan Stockbit (seperti alamat IP Anda, lokasi geografis, jenis browser, jenis ponsel, sumber rujukan, lama kunjungan dan jumlah tampilan halaman)."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Information about your computer/mobile and about your visits to and use of Stockbit (such as your IP address, geographical location, browser type, mobile type, referral source, length of visit and number of page views)."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "account-deletion",
                children: "PENGHAPUSAN REKENING"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "ACCOUNT DELETION"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Anda dapat meminta untuk menghapus rekening Anda kapan saja. Ketika rekening Stockbit Anda dihapus, maka profil, foto, postingan, dan semua hal lain yang Anda tambahkan akan dihapus. Anda tidak akan dapat mengambil apa pun yang telah Anda tambahkan. Ingatlah bahwa informasi yang dibagikan orang lain tentang Anda bukan bagian dari rekening Anda dan tidak akan dihapus saat Anda menghapus rekening Anda."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Anda tidak akan dapat mengaktifkan kembali rekening Anda."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Pengguna dapat menghapus rekening Stockbit dengan mengakses menu: Akun > Profil Akun > Hapus Akun."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Menghapus rekening Stockbit tidak akan menghapus informasi yang tercantum di mesin pencari termasuk namun tidak terbatas pada Google atau Bing karena Stockbit tidak memiliki kendali atas website tersebut."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Ketika rekening Stockbit Anda telah dihapus, postingan yang diberi tag oleh pengguna lain di profil Anda akan tetap muncul, namun profil Anda tidak dapat diakses oleh pengguna lain."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Bila Anda memilih untuk menghapus rekening Anda, kami akan menghapus rekening Anda dari Situs. Beberapa informasi ini dihapus secara permanen dari server kami."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Beberapa informasi, seperti riwayat pesan, tidak disimpan di rekening Anda. Artinya, teman Anda mungkin masih memiliki akses ke pesan yang Anda kirimkan setelah rekening Anda dihapus."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Jika Anda ingin menutup rekening perdagangan Anda di PT Stockbit Sekuritas Digital, silahkan menghubungi Customer Support kami."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Pastikan Anda sudah mengosongkan tip jar Anda, karena Stockbit tidak bertanggung jawab atas hilangnya tip yang mungkin masih ada di rekening Anda."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Alamat email dan nomor telepon Anda tidak dapat digunakan lagi untuk proses pendaftaran selanjutnya."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Nama pengguna rekening Anda tidak dapat lagi digunakan untuk pendaftaran di Stockbit di kemudian hari."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Jika rekening Anda sudah terverifikasi atau berstatus Admin, maka ketika profil Anda dihapus maka status tersebut akan diberhentikan."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Semua aktivitas berlangganan Anda di Stockbit Pro akan hilang setelah penghapusan rekening."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Salinan beberapa materi mungkin tetap ada di database kami karena Stockbit wajib menyimpan informasi dan data terkait rekening Anda sesuai peraturan OJK yang berlaku."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Hubungi tim dukungan pelanggan kami untuk meminta penghapusan data permanen dari sistem kami."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "You can request to delete your account at any time. When your Stockbit account is deleted, your profile, photos, posts, and everything else you've added will be deleted. You won't be able to retrieve anything you've added. Keep in mind that information that others have shared about you is not part of your account and will not be deleted when you delete your account."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                isSecondary: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "You won't be able to reactivate your account."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Users can delete their Stockbit account by accessing the menu: Account > Public Profile > Delete Account."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Deleting a Stockbit account will not delete the information listed on search engines including but not limited to Google or Bing because Stockbit has no control over these websites."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "When your Stockbit account has been deleted, posts tagged by other users on your profile will still appear, but your profile cannot be accessed by other users."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "When you choose to delete your account, we'll remove your account from the site. Some of this information is permanently deleted from our servers."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Some information, such as messaging history, isn't stored in your account. This means that friends may still have access to messages that you sent after your account has been deleted."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "If you want to close your trading account at PT Stockbit Sekuritas Digital, please contact our Customer Support."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Make sure you have emptied your tip jar, because Stockbit will not be responsible for any loss of tips that may still be in your Account."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Your email address and phone number can no longer be used for future registration processes."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Your account username can no longer be used for registration on Stockbit in the future."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "If your account is verified or has Admin status, when your profile is deleted, the status will be dismissed."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "All of your subscription activity on Stockbit Pro will be lost upon account deletion."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Copies of some material may remain in our database as Stockbit is required to keep information and data related to your account according to applicable OJK regulations."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "Contact our customer support team to request for permanent data deletion from our system."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "user-choice-and-transparency",
                children: "PILIHAN PENGGUNA DAN TRANSPARANSI"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "USER CHOICE AND TRANSPARENCY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Perangkat seluler pada umumnya (iOS, Android, dll) memiliki pengaturan sehingga aplikasi Stockbit tidak dapat mengakses data tertentu tanpa persetujuan Pengguna. Perangkat iOS akan memberikan notifikasi kepada Pengguna saat aplikasi Stockbit pertama kali meminta akses data, sedangkan perangkat Android akan memberikan notifikasi kepada Pengguna saat aplikasi Stockbit pertama kali dimuat. Dengan menggunakan aplikasi dan memberikan akses terhadap aplikasi, Pengguna telah mempertimbangkan untuk memberikan persetujuan terhadap Kebijakan Privasi."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Mobile devices in general (iOS, Android, etc.) have settings so that the Stockbit application cannot access certain data without the consent of the User. The iOS device will give a notification to the User when the Stockbit application first requests access to the data, while the Android device will give a notification to the User when the Stockbit application is first loaded. By using the application and giving access to the application, the User has considered giving consent to the Privacy Policy."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: 'Pengguna dapat mengakses dan mengubah informasi berupa alamat email, nomor telepon, tanggal lahir, jenis kelamin, foto profil dan informasi lainnya melalui fitur "pengaturan".'
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: 'The User can access and change information in the form of e-mail address, telephone number, date of birth, gender, profile photo and other information through the "settings" feature.'
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "number-and-contacts-phone",
                children: "NOMOR DAN KONTAK TELEPON"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "NUMBER AND CONTACTS PHONE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Kami tidak akan pernah memindai atau memasukkan kontak Anda kecuali Anda memintanya. Jika Anda memilih untuk melakukannya, kami hanya akan menggunakan informasi kontak Anda untuk membantu Anda menemukan teman atau kontak yang menggunakan Stockbit."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "We will never scan or import your contacts unless you ask us to. If you choose to do so, we will only use your contact information to help you find friends or contacts who use Stockbit."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "information-and-disclosure",
                children: "INFORMASI DAN PENGUNGKAPAN"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "INFORMATION AND DISCLOSURE"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Selain pengungkapan yang diperlukan secara wajar untuk tujuan yang disebutkan di bagian lain dalam Kebijakan Privasi ini, kami dapat mengungkapkan informasi tentang Anda:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "sepanjang kami diharuskan melakukannya oleh hukum;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "sehubungan dengan proses hukum apa pun atau proses hukum yang prospektif (termasuk proses hukum yang direncanakan oleh pihak ketiga, baik terhadap kami, Anda, atau pihak ketiga lainnya);"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "untuk menetapkan, melaksanakan atau membela hak-hak hukum kami (termasuk memberikan informasi kepada orang lain untuk tujuan pencegahan penipuan dan mengurangi risiko kredit); dan"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "kepada pembeli (atau calon pembeli) bisnis atau aset apa pun yang kami (atau rencanakan) jual."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "In addition to the disclosures reasonably necessary for the purposes identified elsewhere in this privacy policy, we may disclose information about you:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled.OL, {
                isSecondary: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "to the extent that we are required to do so by law;"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "in connection with any legal proceedings or prospective legal proceedings (including proceedings contemplated by a third party, whether against us, you or another third party);"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "in order to establish, exercise or defend our legal rights (including providing information to others for the purposes of fraud prevention and reducing credit risk); and"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                        children: "to the purchaser (or prospective purchaser) of any business or asset which we are (or are contemplating) selling."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "underage",
                children: "DI BAWAH UMUR"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "UNDERAGE (MINOR)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Stockbit hanya tersedia bagi setiap orang yang berusia minimal 17 (tujuh belas) tahun dan/atau yang secara hukum dianggap mampu membuat kontrak yang mengikat."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "Stockbit is only available to persons who are at least 17 (seventeen) years old and/or who have been legally deemed to be able to form binding contracts."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled/* Text */.xv, {
                children: [
                    "Apabila kami mengetahui bahwa kami telah mengumpulkan atau menerima data pribadi dari anak yang berusia di bawah 17 (tujuh belas) tahun tanpa persetujuan orang tua atau wali sah Anda dan/atau anak yang berusia di bawah 13 (tiga belas) tahun, maka kami akan menghapus data pribadi tersebut. Jika Anda yakin kami mungkin memiliki informasi apa pun dari atau tentang anak di bawah 13 (tiga belas) tahun dan/atau anak di bawah 17 (tujuh belas) tahun tanpa izin, silahkan menghubungi kami di",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:Support@stockbit.com",
                        children: "Support@stockbit.com"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: [
                    "If we find out that we have collected or received personal data from a child under 17 (seventeen) years of age without the consent of your parents or legal guardians and/or a child under 13 (thirteen) years of age, we will delete that personal data. If you believe we may have any information from or about a child under 13 (thirteen) years and/or a child under 17 (seventeen) years without permission, please contact us at",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:Support@stockbit.com",
                        children: "Support@stockbit.com"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "security",
                children: "KEAMANAN"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "SECURITY"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Kami akan mengambil tindakan pencegahan yang wajar untuk mencegah kehilangan, penyalahgunaan, atau perubahan informasi pribadi Anda."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "We will take reasonable precautions to prevent the loss, misuse, or alteration of your personal information."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Jika Anda memilih untuk mempublikasikan informasi tentang diri Anda di profil publik Anda atau dalam artikel yang Anda pilih untuk dipublikasikan di Situs (keduanya opsional), informasi ini tentu saja akan tersedia untuk umum di internet."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "If you choose to publish information about yourself in your public profile or in articles you choose to publish on the Site (both optional), this information will, of course, be publicly available on the internet."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Meskipun semua informasi pembayaran dikirim melalui protokol yang aman, transmisi data lainnya melalui internet pada dasarnya tidak aman, dan kami tidak dapat menjamin keamanan data yang dikirim melalui internet."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "While all payment information is sent over a secure protocol, other data transmission over the internet is inherently insecure, and we cannot guarantee the security of data sent over the internet."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Anda bertanggung jawab untuk menjaga kerahasiaan kata sandi dan rincian Pengguna Anda. Kami tidak akan menanyakan kata sandi Anda (kecuali saat Anda login)."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "You are responsible for keeping your password and User details confidential. We will not ask you for your password (except when you log in)."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "third-party-services-websites",
                children: "LAYANAN & SITUS WEB PIHAK KETIGA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "THIRD PARTY SERVICES & WEBSITES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Pengguna mungkin akan menemukan iklan atau konten lain di Situs kami yang menghubungkan tautan ke situs dan layanan mitra, pemasok, pengiklan, sponsor, pemberi lisensi, dan pihak ketiga lainnya. Kami tidak mengontrol konten atau tautan yang muncul di situs-situs ini dan tidak bertanggung jawab atas praktik yang dilakukan oleh situs-situs yang tertaut ke atau dari Situs kami."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "Users may find advertising or other content on our Site that links to the sites and services of our partners, suppliers, advertisers, sponsors, licensors and other third parties. We do not control the content or links that appear on these sites and are not responsible for the practices employed by websites linked to or from our Site."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Selain itu, situs atau layanan yang dimaksud di atas, termasuk konten dan tautannya, mungkin akan terus berubah. Situs dan layanan tersebut mungkin memiliki kebijakan privasi dan kebijakan layanan pelanggannya tersendiri. Penjelajahan dan interaksi di situs web lain mana pun, termasuk situs web yang memiliki tautan ke Situs kami tunduk pada syarat dan kebijakan situs web tersebut."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "In addition, these sites or services, including their content and links, may be constantly changing. These sites and services may have their own privacy policies and customer service policies. Browsing and interaction on any other website, including websites which have a link to our Site, is subject to that website's own terms and policies."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Stockbit Sekuritas Digital juga memiliki kerjasama terkait datafeed dengan Bursa Efek Indonesia (BEI). Data yang didapat dari BEI dan sudah mendapat persetujuan dari BEI untuk ditampilkan pada aplikasi maupun website Stockbit Sekuritas Digital."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "Stockbit Sekuritas Digital has a collaboration regarding datafeed with the Indonesian Stock Exchange (BEI). Data obtained from the IDX has received approval from the IDX to be displayed on the Stockbit Sekuritas Digital application and website."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Dalam menggunakan layanan pihak ketiga apa pun yang tersedia melalui Layanan, Anda harus setuju untuk mematuhi dan terikat oleh Ketentuan Layanan, Kebijakan Privasi, atau syarat dan ketentuan lain dari penyedia layanan pihak ketiga dan mitra pialang kami. Misalnya, ketika mengakses layanan broker online yang disediakan oleh PT Stockbit Sekuritas Digital (“Stockbit Sekuritas Digital”) melalui Layanan, Syarat dan Ketentuan Stockbit Sekuritas Digital berlaku untuk semua masalah yang timbul dari penggunaan layanan apa pun yang disediakan kepada Anda melalui Stockbit Sekuritas Digital. Syarat dan Ketentuan Stockbit Sekuritas Digital tersedia di www.stockbit.com. Oleh karena itu, dengan mengakses Stockbit Sekuritas Digital melalui Layanan, Anda mengakui dan menyatakan bahwa Anda telah meninjau dan menerima Syarat dan Ketentuan Stockbit Sekuritas Digital."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "In using any Third-Party Services made available via the Service, you must agree to comply with and be bound by the terms of service, privacy policy, or other terms and conditions of the third-party service providers and our brokerage partners. For example, when accessing online brokerage services provided by PT Stockbit Sekuritas Digital (“Stockbit Sekuritas Digital”) through the Service, Stockbit Sekuritas Digital’s Terms and Conditions apply to all issues arising out of the use of any such services provided to you through Stockbit Sekuritas Digital. Stockbit Sekuritas Digital’s Terms and Conditions are available at www.stockbit.com. Accordingly, by accessing Stockbit Sekuritas Digital through the Service, you acknowledge and represent that you have reviewed and accepted Stockbit Sekuritas Digital’s Terms and Conditions."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "cookies",
                children: "COOKIES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "COOKIES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Cookies adalah file kecil yang secara otomatis akan disimpan di dalam perangkat Pengguna yang menjalankan perangkat dalam bentuk pengelolaan istimewa oleh Pengguna selama berada di Situs."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Cookies are small files that will automatically take place inside the User device that runs the device in the form of preferentially managing the User during the Site."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Cookie terdiri dari informasi yang dikirim oleh server web ke browser web, dan disimpan oleh browser. Informasi tersebut kemudian dikirim kembali ke server setiap kali browser meminta halaman dari server. Hal ini memungkinkan server web untuk mengidentifikasi dan melacak browser web."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "A cookie consists of information sent by a web server to a web browser, and stored by the browser. The information is then sent back to the server each time the browser requests a page from the server. This enables the web server to identify and track the web browser."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Cookies ini tidak dimaksudkan untuk digunakan pada saat mengakses data lain yang Pengguna miliki pada perangkat komputer Pengguna, selain dari apa yang telah Pengguna setujui untuk disampaikan."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "These cookies are not intended to be used when accessing other data that the User has on the User's computer device, other than what the User has agreed to submit."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: 'Kami dapat menggunakan cookie "sesi" dan cookie "persisten" di situs web. Cookie sesi memungkinkan situs web kami melacak Anda saat Anda menavigasi situs web. Cookies yang persisten akan memungkinkan situs web kami mengenali komputer Anda ketika Anda mengunjungi situs web kami.'
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: 'We may use both "session" cookies and "persistent" cookies on the website. The session cookies enable our website to keep track of you whilst you navigate the website. The persistent cookies will enable our website to recognise your computer when you visit our website.'
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Meskipun cookie sesi akan dihapus dari komputer Anda saat Anda menutup browser, cookie persisten akan tetap tersimpan di komputer Anda hingga dihapus, atau hingga mencapai tanggal kedaluwarsa yang ditentukan."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 5,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Whilst session cookies will be deleted from your computer when you close your browser, persistent cookies will remain stored on your computer until deleted, or until they reach a specified expiry date."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: 'Sebagian besar browser mengizinkan Anda menolak menerima cookie. (Misalnya, di Internet Explorer Anda dapat menolak semua cookie dengan mengklik "Alat", "Opsi Internet", "Privasi", dan memilih "Blokir semua cookie" menggunakan pemilih geser.) Namun, hal ini akan berdampak negatif pada kegunaan banyak situs web, termasuk Situs kami.'
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 6,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: 'Most browsers allow you to refuse to accept cookies. (For example, in Internet Explorer you can refuse all cookies by clicking "Tools", "Internet Options", "Privacy", and selecting "Block all cookies" using the sliding selector.) This will, however, have a negative impact upon the usability of many websites, including ours.'
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Stockbit menggunakan fitur Google Analytics Demographics and Interest. Data yang kami peroleh dari fitur-fitur ini akan digunakan untuk pengembangan Situs dan konten Stockbit. Jika Anda tidak ingin data Anda dilacak oleh Google Analytics, Anda dapat menggunakan Google Analytics Add-On Browser Opt-Out."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 7,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Stockbit uses the Google Analytics Demographics and Interest feature. The data we obtain from these features will be used for the development of the Site and Stockbit content. If you don't want your data to be tracked by Google Analytics, you can use the Google Analytics Add-On Browser Opt-Out."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                start: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Stockbit dapat menggunakan fitur-fitur yang disediakan oleh pihak ketiga dalam rangka meningkatkan Layanan dan konten Stockbit, termasuk penyesuaian dan penyajian iklan kepada setiap Pengguna berdasarkan minat atau riwayat kunjungan. Jika Anda tidak ingin iklan Anda ditampilkan berdasarkan penyesuaian tersebut, maka Anda dapat mengaturnya melalui browser."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.OL, {
                isSecondary: true,
                start: 8,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled.LI, {
                    children: "Stockbit may use features provided by third parties in order to improve the Service and content of Stockbit, including the adjustment and presentation of advertisements to each User based on interest or visit history. If you don't want your ad to be displayed based on these adjustments, then you can set it through a browser."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "policy-amendments",
                children: "PERUBAHAN KEBIJAKAN"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "POLICY AMENDMENTS"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Stockbit dari waktu ke waktu berhak memperbarui Kebijakan Privasi ini agar tetap relevan dan terkini dengan perubahan teknologi, hukum yang berlaku, inovasi Stockbit yang terus berkembang dan kebutuhan pengguna, dan sebaiknya Anda memeriksa halaman ini sesekali untuk memastikan Anda sudah mengetahui perubahan apa pun."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "Stockbit from time to time has the right to renew this Privacy Policy so that it remains relevant and up-to-date with changing technology, applicable laws, Stockbit innovations that continue to evolve and user needs, and you should check this page occasionally to ensure you are familiar with any changes."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                id: "contact",
                children: "KONTAK"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Title */.Dx, {
                isSecondary: true,
                children: "CONTACT"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                children: "Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, praktik situs ini, atau perihal lainnya yang berkaitan dengan situs ini, silakan hubungi kami di:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled/* Text */.xv, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "RDTX Square, Lantai 33"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Jl. Prof. Dr. Satrio No 164 - Jakarta 12930"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Telepon: +62 21 50959330"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Whatsapp business: +62 21 50864219"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Email: Support@stockbit.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "Jam Operasional: 09:00 - 16.30"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: "If you have any questions about this Privacy Policy, the practices of this site, or your dealings with this site, please contact us at:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(contents_styled/* Text */.xv, {
                isSecondary: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "RDTX Square, 33rd Floor"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Jl. Prof. Dr. Satrio No 164 - Jakarta 12930"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Phone: +62 21 50959330"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Whatsapp business: +62 21 50864219"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Email: Support@stockbit.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                        children: "Operational hours: 09:00 - 16.30"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var privacy = (Privacy);

;// CONCATENATED MODULE: ./pages/privacy.tsx

__webpack_require__(14473);




var UserArticleLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(74885), __webpack_require__.e(25287), __webpack_require__.e(94119), __webpack_require__.e(78656), __webpack_require__.e(71577), __webpack_require__.e(75819), __webpack_require__.e(46819), __webpack_require__.e(42871), __webpack_require__.e(12603), __webpack_require__.e(7648), __webpack_require__.e(25935), __webpack_require__.e(97751), __webpack_require__.e(80129), __webpack_require__.e(51225), __webpack_require__.e(36661), __webpack_require__.e(27251), __webpack_require__.e(53954), __webpack_require__.e(29117), __webpack_require__.e(50626), __webpack_require__.e(46406), __webpack_require__.e(20228), __webpack_require__.e(67555), __webpack_require__.e(78497), __webpack_require__.e(265), __webpack_require__.e(91036), __webpack_require__.e(54253), __webpack_require__.e(48761), __webpack_require__.e(47407), __webpack_require__.e(88042), __webpack_require__.e(6916), __webpack_require__.e(64435), __webpack_require__.e(48308), __webpack_require__.e(72454), __webpack_require__.e(70814), __webpack_require__.e(74768), __webpack_require__.e(40927), __webpack_require__.e(77284), __webpack_require__.e(74317), __webpack_require__.e(6870), __webpack_require__.e(86191)]).then(__webpack_require__.bind(__webpack_require__, 12661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12661)
            ];
        }
    }
});
var ArticleLayout = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(25287), __webpack_require__.e(94119), __webpack_require__.e(71577), __webpack_require__.e(75819), __webpack_require__.e(42871), __webpack_require__.e(12603), __webpack_require__.e(97751), __webpack_require__.e(10534), __webpack_require__.e(85591)]).then(__webpack_require__.bind(__webpack_require__, 10534));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10534)
            ];
        }
    }
});
var PrivacyPage = function(param) {
    var isLoggedIn = param.isLoggedIn, mode = param.mode;
    if (isLoggedIn) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserArticleLayout, {
            source: /*#__PURE__*/ (0,jsx_runtime.jsx)(privacy, {}),
            title: "Privacy"
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
        theme: theme/* privacyPageTheme */.V3[mode] || theme/* privacyPageTheme.light */.V3.light,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleLayout, {
            source: /*#__PURE__*/ (0,jsx_runtime.jsx)(privacy, {}),
            title: "Privacy"
        })
    });
};
var __N_SSP = true;
/* harmony default export */ var pages_privacy = (PrivacyPage);


/***/ }),

/***/ 30079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T3": function() { return /* binding */ Page; },
/* harmony export */   "V3": function() { return /* binding */ privacyPageTheme; }
/* harmony export */ });
/* unused harmony export Theme */
var theme = {};
var Theme;
(function(Theme) {
    Theme["dark"] = "dark";
    Theme["light"] = "light";
})(Theme || (Theme = {}));
var Page;
(function(Page) {
    Page["privacyDark"] = "privacy-page-dark";
    Page["privacyLight"] = "privacy-page-light";
})(Page || (Page = {}));
var privacyPageTheme = {
    dark: {
        page: Page.privacyDark,
        textPrimary: "#cbcbcb",
        textSecondary: "#858585",
        backgroundPrimary: "#121212",
        backgroundSecondary: "#121212",
        borderPrimary: "#121212"
    },
    light: {
        page: Page.privacyLight,
        textPrimary: "#333333",
        textSecondary: "#858585",
        backgroundPrimary: "#ffffff",
        backgroundSecondary: "#f2f2f2",
        borderPrimary: "#dadada"
    }
};

/* harmony default export */ __webpack_exports__["ZP"] = (theme);


/***/ }),

/***/ 25175:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dx": function() { return /* binding */ Title; },
/* harmony export */   "LI": function() { return /* binding */ LI; },
/* harmony export */   "OL": function() { return /* binding */ OL; },
/* harmony export */   "UL": function() { return /* binding */ UL; },
/* harmony export */   "W2": function() { return /* binding */ Container; },
/* harmony export */   "xv": function() { return /* binding */ Text; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n  color: #333333;\n  margin-bottom: 10px;\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-weight: bold;\n  margin: 0;\n  color: #333333;\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: #333333;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-left: 15px;\n  color: #333333;\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f21dcb6a-0"
})(_templateObject());
var Text = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-f21dcb6a-1"
})(_templateObject1(), function(param) {
    var isSecondary = param.isSecondary, theme = param.theme;
    return isSecondary && "\n      color: ".concat(theme.textSecondary, " !important;\n      font-size: 13px;\n      font-style: italic;\n      margin-bottom: 14px;\n    ");
});
var Title = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
    componentId: "sc-f21dcb6a-2"
})(_templateObject2(), function(param) {
    var isSecondary = param.isSecondary, theme = param.theme;
    return isSecondary && "\n      color: ".concat(theme.textSecondary, " !important;\n      font-size: 13px;\n      font-style: italic;\n      margin-bottom: 10px;\n    ");
});
var OL = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ol.withConfig */ .ZP.ol.withConfig({
    componentId: "sc-f21dcb6a-3"
})(_templateObject3(), function(param) {
    var isSecondary = param.isSecondary, theme = param.theme;
    return isSecondary && "\n      color: ".concat(theme.textSecondary, " !important;\n      font-style: italic;\n\n      li {\n        font-size: 13px;\n      }\n    ");
});
var UL = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
    componentId: "sc-f21dcb6a-4"
})(_templateObject4(), function(param) {
    var isSecondary = param.isSecondary, theme = param.theme;
    return isSecondary && "\n      color: ".concat(theme.textSecondary, " !important;\n      font-style: italic;\n\n      li {\n        font-size: 13px;\n      }\n    ");
});
var LI = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-f21dcb6a-5"
})(_templateObject5());


/***/ }),

/***/ 20:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/backpack/1.0.0/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["backpack"]) {
      return resolve(window.remoteLoading["backpack"])
    }

    var res, rej;
    window.remoteLoading["backpack"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["backpack"] !== 'undefined') {
      res(window["backpack"]);
      return resolve(window["backpack"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["backpack"] !== 'undefined') {
          res(window["backpack"]);
          return resolve(window["backpack"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "backpack"
    );
  }).then(function () {
    const proxy = {
      get: backpack.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          backpack.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        backpack.__initialized = true
      }
    }
    if (!backpack.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 29191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/buy-sell/1.7.12/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["buysell"]) {
      return resolve(window.remoteLoading["buysell"])
    }

    var res, rej;
    window.remoteLoading["buysell"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["buysell"] !== 'undefined') {
      res(window["buysell"]);
      return resolve(window["buysell"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["buysell"] !== 'undefined') {
          res(window["buysell"]);
          return resolve(window["buysell"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "buysell"
    );
  }).then(function () {
    const proxy = {
      get: buysell.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          buysell.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        buysell.__initialized = true
      }
    }
    if (!buysell.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 63329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/fast-trade/3.0.3/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["fasttrade"]) {
      return resolve(window.remoteLoading["fasttrade"])
    }

    var res, rej;
    window.remoteLoading["fasttrade"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["fasttrade"] !== 'undefined') {
      res(window["fasttrade"]);
      return resolve(window["fasttrade"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["fasttrade"] !== 'undefined') {
          res(window["fasttrade"]);
          return resolve(window["fasttrade"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "fasttrade"
    );
  }).then(function () {
    const proxy = {
      get: fasttrade.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          fasttrade.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        fasttrade.__initialized = true
      }
    }
    if (!fasttrade.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 6019:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/movers/1.0.4/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["movers"]) {
      return resolve(window.remoteLoading["movers"])
    }

    var res, rej;
    window.remoteLoading["movers"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["movers"] !== 'undefined') {
      res(window["movers"]);
      return resolve(window["movers"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["movers"] !== 'undefined') {
          res(window["movers"]);
          return resolve(window["movers"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "movers"
    );
  }).then(function () {
    const proxy = {
      get: movers.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          movers.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        movers.__initialized = true
      }
    }
    if (!movers.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ }),

/***/ 85611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
module.exports = new Promise(function (resolve, reject) {
    var url = new URL("https://storage.stockbit.com/top-stocks/1.0.1/static/remoteEntry.js");
    url.searchParams.set('t', Date.now());
    var __webpack_error__ = new Error();
    if(!window.remoteLoading) {
        window.remoteLoading = {};
    };

    if(window.remoteLoading["topstocks"]) {
      return resolve(window.remoteLoading["topstocks"])
    }

    var res, rej;
    window.remoteLoading["topstocks"] = new Promise(function(rs,rj){
      res = rs;
      rej = rj;
    })

    if (typeof window["topstocks"] !== 'undefined') {
      res(window["topstocks"]);
      return resolve(window["topstocks"]);
    }

     __webpack_require__.l(
      url.href,
      function (event) {
        if (typeof window["topstocks"] !== 'undefined') {
          res(window["topstocks"]);
          return resolve(window["topstocks"]);
        }
        var errorType = event && (event.type === 'load' ? 'missing' : event.type);
        var realSrc = event && event.target && event.target.src;
        __webpack_error__.message =
          'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
        __webpack_error__.name = 'ScriptExternalLoadError';
        __webpack_error__.type = errorType;
        __webpack_error__.request = realSrc;
        rej(__webpack_error__);
        reject(__webpack_error__);
      },
      "topstocks"
    );
  }).then(function () {
    const proxy = {
      get: topstocks.get,
      init: function(shareScope, initToken) {

        const handler = {
          get(target, prop) {
            if (target[prop]) {
              Object.values(target[prop]).forEach(function(o) {
                if(o.from === '_N_E') {
                  o.loaded = 1
                }
              })
            }
            return target[prop]
          },
          set(target, property, value, receiver) {
            if (target[property]) {
              return target[property]
            }
            target[property] = value
            return true
          }
        }
        try {
          topstocks.init(new Proxy(shareScope, handler), initToken)
        } catch (e) {

        }
        topstocks.__initialized = true
      }
    }
    if (!topstocks.__initialized) {
      proxy.init(__webpack_require__.S.default)
    }
    return proxy
  });

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [63332,49774,92888,40179], function() { return __webpack_exec__(93027); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);